<template>
  <layout-default>
    <span slot="title">{{ room.name }}</span>
    <div class="row">
      <div class="col">
        <router-link
          :to="{ path: '/' }"
          tag="button"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-150 ease-in-out bg-gray-400 hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray focus:border-gray-600 active:bg-gray-600"
        >
          <font-awesome-icon
            :icon="['fad', 'backward']"
            size="lg"
            fixed-width
          />
        </router-link>
      </div>
    </div>
    <div v-if="room.screen_down_pin > 0" class="grid grid-cols-4 gap-4 mt-4">
      <div class="col-span-2">
        Screen
      </div>
      <div>
        <button
          @click.prevent="screen('down')"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-150 ease-in-out bg-blue-400 hover:bg-blue-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-600 active:bg-blue-600"
        >
          <font-awesome-icon
            :icon="['fad', 'arrow-down']"
            size="lg"
            fixed-width
          />
        </button>
      </div>
      <div>
        <button
          @click.prevent="screen('up')"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-150 ease-in-out bg-blue-400 hover:bg-blue-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-600 active:bg-blue-600"
        >
          <font-awesome-icon
            :icon="['fad', 'arrow-up']"
            size="lg"
            fixed-width
          />
        </button>
      </div>
    </div>
    <div v-if="room.projector_ip != ''" class="grid grid-cols-4 gap-4 mt-4">
      <div class="col-span-2">
        Projector
      </div>
      <div>
        <button
          @click.prevent="projector('on')"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-150 ease-in-out bg-blue-400 hover:bg-blue-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-600 active:bg-blue-600"
        >
          <font-awesome-icon :icon="['fad', 'sun']" size="lg" fixed-width />
        </button>
      </div>
      <div>
        <button
          @click.prevent="projector('off')"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-150 ease-in-out bg-blue-400 hover:bg-blue-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-600 active:bg-blue-600"
        >
          <font-awesome-icon :icon="['fad', 'moon']" size="lg" fixed-width />
        </button>
      </div>
    </div>
    <div class="grid grid-cols-4 gap-4 mt-4">
      <div class="col-span-2">
        Source
      </div>
      <div class="col-span-2">
        <div class="mt-1 sm:mt-0 sm:col-span-2">
          <div class="max-w-lg rounded-md shadow-sm sm:max-w-xs">
            <select
              @change="source($event)"
              v-model="selectedroomid"
              class="block form-select w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
            >
              <option v-for="room in rooms" :key="room.id" :value="room.id">
                {{ room.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div>
      Audio
    </div>
    <div class="grid grid-cols-4 gap-4 mt-4">
      <div v-for="(channel, index) in mychannels" :key="index" class="text-center">
        {{ channelname(channel.channel) }}<br/>
        <input type="range" min="0" max="0.75" step="any" orient="vertical" :disabled="isLocked(channel.channel)" :value="channel.level" :data-bus="channel.bus" :data-channel="channel.channel" @input.prevent="level($event)">
      </div>
    </div>
  </layout-default>
</template>
<script>
import LayoutDefault from "@/components/layouts/LayoutDefault.vue";
import axios from "axios";

export default {
  name: "Room",
  components: {
    LayoutDefault
  },
  data() {
    return {
      selroomid: 0
    };
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    rooms() {
      return this.$store.state.rooms;
    },
    room() {
      return this.rooms.find(room => room.id === Number(this.id));
    },
    selectedroomid: {
      get() {
        return this.selroomid || this.id;
      },
      set(value) {
        this.selroomid = value;
      }
    },
    mychannels: {
      get() {
        return this.$store.state.mixer.filter(mixer => mixer.bus === "0" + this.id);
      }
    },
    channels() {
      return this.$store.state.channels;
    }
  },
  methods: {
    screen(mode) {
      axios.defaults.headers.common["Authorization"] =
        this.$store.state.session.token_type +
        " " +
        this.$store.state.session.access_token;
      axios.get("/room/" + this.id + "/screen/" + mode);
    },
    projector(mode) {
      axios.defaults.headers.common["Authorization"] =
        this.$store.state.session.token_type +
        " " +
        this.$store.state.session.access_token;
      axios.get("/room/" + this.id + "/projector/" + mode);
    },
    source(event) {
      axios.defaults.headers.common["Authorization"] =
        this.$store.state.session.token_type +
        " " +
        this.$store.state.session.access_token;
      axios.get("/room/" + this.id + "/display/" + event.srcElement.value);
    },
    level(event) {
      this.$socket.emit("message", {
        address: "/ch/" + event.srcElement.dataset.channel + "/mix/" + event.srcElement.dataset.bus,
        args: [{
          type: "f",
          value: event.srcElement.value
        }]
      });
    },
    channelname(channelstring) {
      return this.channels.find(channel => channel.channel === channelstring).name;
    },
    isLocked(channelstring) {
      return this.room.lockout_channel === channelstring;
    }
  },
  created() {
    if (this.rooms.length === 0) {
      this.$router.push("/");
    }
    axios.defaults.headers.common["Authorization"] =
      this.$store.state.session.token_type +
      " " +
      this.$store.state.session.access_token;
    axios.get("/networkswitch/" + this.id).then(response => {
      if (response && response.data && response.data.id > 0) {
        this.selectedroomid = response.data.id;
      }
    });
    var busid = "0" + this.id;
    this.$socket.emit("message", { address: "/ch/01/mix/" + busid });
    this.$socket.emit("message", { address: "/ch/02/mix/" + busid });
    this.$socket.emit("message", { address: "/ch/03/mix/" + busid });
    this.$socket.emit("message", { address: "/ch/04/mix/" + busid });
    this.$socket.emit("message", { address: "/ch/05/mix/" + busid });
    this.$socket.emit("message", { address: "/ch/06/mix/" + busid });
    this.$socket.emit("message", { address: "/ch/07/mix/" + busid });
    this.$socket.emit("message", { address: "/ch/08/mix/" + busid });
    this.$socket.emit("message", { address: "/ch/09/mix/" + busid });
  }
};
</script>
